// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__12698","tempChatList":"styles_tempChatList__3QP2W","childFullWidth":"styles_childFullWidth__1edfM"};